import { s as scrollToInternal, g as getNewScrollPosition, r as requestAnimFrame } from './55674673.mjs';
import { w as whichTransitionEndEvent } from './93b89dd4.mjs';

const easings = Object.freeze({
  linear(t) {
    return t;
  },
  easeOutCubic(t) {
    return --t * t * t + 1;
  }
});

function scrollTo(target, duration, easing = "easeOutCubic") {
  const windowTop = typeof window.scrollY === "undefined" ? window.pageYOffset : window.scrollY;
  let position;
  if (typeof target === "object" && !!target.getBoundingClientRect) {
    position = target.getBoundingClientRect().top + windowTop - 20;
  } else if (typeof target === "number") {
    position = target;
  } else {
    throw new Error(
      "Invalid target for scrollTo() method. Element has to be an object with an offsetTop function or number, which stands for the page position."
    );
  }
  const easingFnc = easings[easing];
  if (!easingFnc) {
    throw new Error(`Unknown easing function for scrollTo() method: ${easing}`);
  }
  let scrollBase = document.documentElement;
  const currentPos = scrollBase.scrollTop;
  let ratio;
  if (currentPos === 0) {
    ratio = window.devicePixelRatio ? window.devicePixelRatio : 1;
    scrollBase.scrollTop += Math.max(1, ratio, 1 / ratio);
    scrollBase = scrollBase.scrollTop > 0 ? scrollBase : document.body;
    scrollBase.scrollTop = 0;
  }
  const maxScroll = scrollBase.scrollHeight - scrollBase.offsetHeight;
  if (maxScroll < position) {
    position = maxScroll;
  }
  if (duration < 16) {
    scrollBase.scrollTop = position;
    return;
  }
  scrollToInternal(scrollBase, currentPos, position, 0, duration, easingFnc);
}

const transitions = Object.freeze({
  fadeOut: "p_animation__fadeOut",
  fadeIn: "p_animation__fadeIn"
});
function transition(target, transitionClass, callback) {
  if (typeof target === "object" && typeof transitionClass === "string") {
    const transitionEndEvent = whichTransitionEndEvent();
    const callbackHandler = (e) => {
      if (typeof callback === "function") {
        callback();
      }
      if (e && e.target) {
        e.target.removeEventListener(transitionEndEvent, callbackHandler);
      }
    };
    if (transitionEndEvent && typeof callback === "function" && !target.classList.contains(transitionClass)) {
      target.addEventListener(transitionEndEvent, callbackHandler);
      target.classList.add(transitionClass);
    } else {
      target.classList.add(transitionClass);
      callbackHandler();
    }
  } else {
    throw new Error("No target or class specified");
  }
}

function fadeOut(target, callback) {
  if (window.getComputedStyle(target).opacity !== "0") {
    transition(target, transitions.fadeOut, callback);
  } else if (typeof callback === "function") {
    callback();
  }
}
function fadeIn(target, callback) {
  if (window.getComputedStyle(target).opacity !== "1") {
    transition(target, transitions.fadeIn, callback);
  } else if (typeof callback === "function") {
    callback();
  }
}

var index = /*         */Object.freeze({
  __proto__: null,
  _getNewScrollPosition: getNewScrollPosition,
  _scrollTo: scrollToInternal,
  easings: easings,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  requestAnimFrame: requestAnimFrame,
  scrollTo: scrollTo,
  transition: transition,
  transitions: transitions
});

export { transitions as a, fadeOut as b, easings as e, fadeIn as f, index as i, scrollTo as s, transition as t };
/*                                 */
